import { memo, useEffect } from 'react';
import { View, Text, StyleSheet, FlatList, Pressable } from 'react-native';

import { I18n, Navigation, ProfileAvatar, TextUtils } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';
import { SUCCESS, REQUESTING } from '../../actions/statusTypes';

import { useDispatch, useSelector } from 'react-redux';
import { fetchTopicsAndMessage } from './actions';

import moment from 'moment';

import { getBroadcastMessages } from './selector';
import { currentEmployerPermissions } from '../../helpers/permissions';
import { BROADCAST_MESSAGING } from '../../constants/permissions';

function renderItem({ item }) {
  const displayDate = moment(item.updated);
  return (
    <View style={styles.rowItem}>
      <View style={THEME.basicRow}>
        <View style={[styles.dateSide, { flexGrow: 1 }]} />
        <Text style={[styles.dateLabel, { flexGrow: 1 }]}>
          {TextUtils.ac(displayDate.format('MMM DD, YYYY'))}
        </Text>
        <View style={[styles.dateSide, { flexGrow: 1 }]} />
        <View />
      </View>
      <View style={styles.content}>
        <ProfileAvatar profile={item.member} circleStyles={{ width: 25, height: 25 }} />
        <View style={styles.textContainer}>
          <Text style={styles.nameLabel}>
            {item.member.rank} {item.member.fullName}
          </Text>
          <Text style={styles.messageText}>{item.text}</Text>
        </View>
      </View>
    </View>
  );
}

function handleSendPress() {
  Navigation.showModal({ screen: 'Broadcast', title: I18n.ac('messaging.newBroadcast') });
}

export default memo((props) => {
  const dispatch = useDispatch();
  const broadCastMessages = useSelector(getBroadcastMessages);
  const canSendBroadcast = currentEmployerPermissions(BROADCAST_MESSAGING).canEdit;
  const fetchAllMessagesStatus = useSelector((state) => state.screens.messaging.fetchAllStatus);

  useEffect(() => {
    if (fetchAllMessagesStatus !== SUCCESS && fetchAllMessagesStatus !== REQUESTING) {
      dispatch(fetchTopicsAndMessage());
    }
  }, [fetchAllMessagesStatus, dispatch]);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerLabel}>Broadcasts</Text>
        {!!canSendBroadcast && (
          <Pressable style={styles.sendBroadcastBtn} onPress={handleSendPress}>
            <Text style={styles.sendBroadcastLabel}>Send Broadcast</Text>
          </Pressable>
        )}
      </View>
      <FlatList
        data={broadCastMessages}
        renderItem={renderItem}
        keyExtractor={(item) => `${item.messageId}`}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        width: 400,
        height: 400,
        borderRadius: 10,
        overflow: 'hidden',
      }
    : { flex: 1 },
  header: {
    ...THEME.basicRow,
    backgroundColor: COLOR.altContrast,
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  sendBroadcastBtn: {
    paddingHorizontal: 10,
  },
  headerLabel: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 12,
    flex: 1,
  },
  sendBroadcastLabel: {
    ...THEME.linkStyle,
  },
  rowItem: {
    paddingHorizontal: 15,
    paddingVertical: 15,
  },
  content: {
    ...THEME.basicRow,
    marginTop: 15,
  },
  dateLabel: {
    flex: 1,
    ...FONT.medium,
    color: COLOR.textLight,
    fontSize: 12,
    textAlign: 'center',
  },
  timeLabel: {},
  textContainer: {
    flex: 1,
    paddingLeft: 15,
    paddingRight: 15,
  },
  nameLabel: {
    ...FONT.bold,
    color: COLOR.text,
    fontSize: 12,
    marginBottom: 5,
  },
  messageText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 12,
  },
  dateSide: {
    height: 1,
    backgroundColor: COLOR.accent,
  },
});
